import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { draftInvoiceSchema } from './schemas';
import { invoiceQueryOptions } from './useInvoice';

export const useDuplicateInvoice = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data: invoice } = await fetchJson(`/invoices/${id}/duplicate`, {
        method: 'POST',
        schema: apiResourceSchema(draftInvoiceSchema),
      });

      return invoice;
    },
    onSuccess: (invoice) => {
      queryClient.setQueryData(invoiceQueryOptions(invoice.id).queryKey, invoice);
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoices.index.root });
    },
  });
};
